var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hangle cell"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M10.3425 14.8881C9.88546 15.298 9.88591 15.9766 10.3434 16.386L15.5 21L20.6566 16.386C21.1141 15.9766 21.1145 15.298 20.6575 14.8881C20.2211 14.4966 19.5279 14.4961 19.0907 14.8868L16.6386 17.0788L16.6386 10.0536C16.6386 9.4717 16.1288 9 15.5 9C14.8712 9 14.3614 9.4717 14.3614 10.0536L14.3614 17.0788L11.9093 14.8868C11.4721 14.4961 10.7789 14.4966 10.3425 14.8881Z",
    fill: "#2CA85E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrow);
export default __webpack_public_path__ + "static/media/green_arrow.2da3a115364545d7f74ed389a40b6b25.svg";
export { ForwardRef as ReactComponent };